import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Shield, Store, LogOut, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { BottomNav } from '../components/BottomNav';
import { StatusBadge } from '../components/StatusBadge';
import { profileData } from '../data/mockData';
export function Profile() {
  const navigate = useNavigate();
  const menuItems = [{
    icon: Shield,
    label: 'KYC Verification',
    path: '/profile/kyc',
    color: 'text-[#00D68F]'
  }, {
    icon: Building2,
    label: 'Bank Details',
    path: '/profile/bank',
    color: 'text-[#FFBE0B]'
  }, {
    icon: Store,
    label: 'Store Preview',
    path: '/store-preview',
    color: 'text-[#4CC9F0]'
  }, {
    icon: LogOut,
    label: 'Logout',
    path: '/',
    color: 'text-[#FF4757]'
  }];
  return <div className="min-h-screen pb-24" data-id="element-355">
      <div className="max-w-md mx-auto" data-id="element-356">
        {/* Header */}
        <div className="p-5 pt-8" data-id="element-357">
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-358">
            Profile
          </h1>
        </div>

        <div className="px-5 space-y-5" data-id="element-359">
          {/* Profile Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="glass-card p-6" data-id="element-360">
            <div className="flex items-center gap-5 mb-6" data-id="element-361">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#00D68F] to-[#00B377] flex items-center justify-center text-[#0A0E1A] text-2xl font-bold ring-4 ring-[#00D68F]/20 shadow-[0_0_20px_rgba(0,214,143,0.3)]" data-id="element-362">
                {profileData.name.split(' ').map(n => n[0]).join('')}
              </div>
              <div className="flex-1" data-id="element-363">
                <h2 className="text-white text-xl font-bold tracking-tight" data-id="element-364">
                  {profileData.name}
                </h2>
                <p className="text-[#64748B] font-medium" data-id="element-365">
                  {profileData.email}
                </p>
              </div>
            </div>

            <div className="space-y-4 pt-4 border-t border-white/[0.06]" data-id="element-366">
              <div className="flex items-center justify-between" data-id="element-367">
                <span className="text-label" data-id="element-368">Verification</span>
                <StatusBadge status="verified" data-id="element-369" />
              </div>
              <div className="flex items-center justify-between" data-id="element-370">
                <span className="text-label" data-id="element-371">Total Sales</span>
                <span className="text-white font-bold tracking-tight" data-id="element-372">
                  {profileData.totalSales}
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-373">
                <span className="text-label" data-id="element-374">Rating</span>
                <span className="text-white font-bold tracking-tight" data-id="element-375">
                  ⭐ {profileData.rating}
                </span>
              </div>
            </div>
          </motion.div>

          {/* Bank Details Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05
        }} className="glass-card p-5 cursor-pointer group" onClick={() => navigate('/profile/bank')} data-id="element-376">
            <div className="flex items-center justify-between" data-id="element-377">
              <div className="flex items-center gap-4" data-id="element-378">
                <div className="w-10 h-10 rounded-full bg-[#FFBE0B]/10 flex items-center justify-center" data-id="element-379">
                  <Building2 className="w-5 h-5 text-[#FFBE0B]" data-id="element-380" />
                </div>
                <div data-id="element-381">
                  <p className="text-white font-bold tracking-tight" data-id="element-382">
                    Bank Account
                  </p>
                  {profileData.bankDetails.isLinked ? <p className="text-[#64748B] text-sm" data-id="element-383">
                      {profileData.bankDetails.bankName} • ****
                      {profileData.bankDetails.accountNumber.slice(-4)}
                    </p> : <p className="text-[#FF4757] text-sm font-medium" data-id="element-384">
                      Not linked — tap to add
                    </p>}
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-385">
                {profileData.bankDetails.isLinked && <div className="w-2 h-2 rounded-full bg-[#00D68F]" data-id="element-386" />}
                <ChevronRight className="w-5 h-5 text-white/20 group-hover:text-white/50 transition-colors" data-id="element-387" />
              </div>
            </div>
          </motion.div>

          {/* Reseller Status */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="bg-[#00D68F]/[0.06] border border-[#00D68F]/20 rounded-2xl p-5 text-center" data-id="element-388">
            <p className="text-[#00D68F] font-bold text-lg tracking-tight mb-1" data-id="element-389">
              ✓ Verified Reseller
            </p>
            <p className="text-[#00D68F]/70 text-sm font-medium" data-id="element-390">
              Member since{' '}
              {new Date(profileData.joinDate).toLocaleDateString('en-NG', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>

          {/* Menu Items */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="glass-card overflow-hidden" data-id="element-391">
            {menuItems.map((item, index) => {
            const Icon = item.icon;
            return <motion.button key={item.label} whileTap={{
              scale: 0.98
            }} onClick={() => navigate(item.path)} className={`w-full flex items-center justify-between p-5 hover:bg-white/[0.06] transition-colors group ${index < menuItems.length - 1 ? 'border-b border-white/[0.06]' : ''}`} data-id="element-392">
                  <div className="flex items-center gap-4" data-id="element-393">
                    <div className="w-10 h-10 rounded-full bg-white/[0.04] flex items-center justify-center group-hover:bg-white/[0.08] transition-colors" data-id="element-394">
                      <Icon className={`w-5 h-5 ${item.color}`} data-id="element-395" />
                    </div>
                    <span className="font-bold tracking-tight text-white" data-id="element-396">
                      {item.label}
                    </span>
                  </div>
                  <ChevronRight className="w-5 h-5 text-white/20 group-hover:text-white/50 transition-colors" data-id="element-397" />
                </motion.button>;
          })}
          </motion.div>
        </div>
      </div>

      <BottomNav data-id="element-398" />
    </div>;
}